import { Icon, Text } from "@src/straps/base";
import { IconNames } from "@src/straps/base/icons/Icon/types";
import { TextVariants } from "@src/straps/base/type/Text/Text";
import classNames from "classnames";

export default function StatusNode({
  fill,
  bgColor,
  icon,
  iconColor,
  title,
  textVariant = "sb_t-12-500",
  smallIcon,
  dataTestId,
}: Readonly<{
  fill?: boolean;
  bgColor?: string;
  icon: IconNames;
  iconColor: string;
  title: string;
  textVariant?: TextVariants;
  smallIcon?: boolean;
  dataTestId: string;
}>) {
  return (
    <div
      className={classNames(
        "flex items-center justify-center rounded-md py-1",
        bgColor,
        { "max-w-min": !fill, "px-2": bgColor }
      )}
      data-testid={dataTestId}
    >
      <Icon
        name={icon}
        className={classNames(iconColor, { "scale-50": smallIcon })}
      />
      <Text variant={textVariant} className="ml-1 mt-px whitespace-nowrap">
        {title}
      </Text>
    </div>
  );
}
